import { authServerInstance } from "../axiosInstance";

export const geoDropdownById = async ({ searchText, params, id }) => {
  try {
    const response = await authServerInstance.post(`/geo/dropdown/${id}`, {
      params,
      searchText: searchText,
    });

    return response.data.map((item) => ({
      key: item.key,
      title: item.title,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const geoFieldsById = async (id) => {
  try {
    const response = await authServerInstance.get(`/geo/fields/${id}`);
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const geoSearch = async (payload) => {
  try {
    const response = await authServerInstance.post("/geo/search", payload);
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const createGeoUnit = async (gldId, payload) => {
  try {
    const response = await authServerInstance.post(
      `/geo/bulk/${gldId}`,
      payload
    );
  } catch (e) {
    console.error(e);
  }
};

export const existsGeoUnit = async (gldId, existsData) => {
  try {
    const response = await authServerInstance.post(
      `/geo/exists/${gldId}`,
      existsData
    );
    return response.data;
  } catch (e) {
    console.log(e);
  }
};

export const getGeoUnitById = async (gldId, id) => {
  try {
    const response = await authServerInstance.get(`/geo/${gldId}/${id}`);
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const updateGeoUnitById = async (gldId, id, payload) => {
  try {
    const response = await authServerInstance.put(
      `geo/update/${gldId}/${id}`,
      payload
    );
  } catch (e) {
    console.log(e);
  }
};
